import { Grid, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import footerimg from "./Assets/footer.png";
import { FiInstagram } from "react-icons/fi";
import { FaDiscord } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import useMediaQuery from "@mui/material/useMediaQuery";
import leftH from "./Assets/leftH.png";
import rightH from "./Assets/rightH.png";

import RubberBand from "react-reveal/RubberBand";

const Footer = () => {
  const matches = useMediaQuery("(max-width:900px)");

  return (
    <div>
      <Box
        sx={{
          backgroundColor: "#101440",
          padding: "40px 0px 40px 0px",
          textAlign: "center",
        }}
      >
        <Grid container>
          <Grid item xs={12} md={4}>
            <img
              style={{
                maxWidth: "180px",
                width: "100%",
                display: matches ? "none" : "block",
              }}
              className="zoom-in-out-box"
              src={leftH}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            {/* <RubberBand> */}
            <img style={{ maxWidth: "60%" }} src={footerimg} />
            <Box
              width={{ xs: "60%", sm: "30%", md: "60%" }}
              margin="auto"
              mt={2}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                {/* <Box
                    width="50px"
                    height="50px"
                    sx={{
                      backgroundColor: "#CF1B52",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FiInstagram
                      style={{
                        fontSize: "30px",
                        color:"white"
                      }}
                    />
                  </Box> */}
                <a
                  style={{ textDecoration: "none" }}
                  href=" https://discord.com/invite/soulmapes"
                  target="_blank"
                >
                  <Box
                    width="50px"
                    height="50px"
                    mx={2}
                    sx={{
                      "&:hover": {
                        background: "#101440",
                      },
                      backgroundColor: "#CF1B52",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaDiscord
                      style={{
                        fontSize: "30px",
                        color: "white",
                      }}
                    />
                  </Box>
                </a>
                <a
                  style={{ textDecoration: "none" }}
                  href="  https://twitter.com/soulmapes"
                  target="_blank"
                >
                  <Box
                    width="50px"
                    height="50px"
                    mx={2}
                    sx={{
                      "&:hover": {
                        background: "#101440",
                      },
                      backgroundColor: "#CF1B52",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BsTwitter
                      style={{
                        fontSize: "30px",
                        color: "white",
                      }}
                    />
                  </Box>
                </a>
              </Stack>
            </Box>
            {/* </RubberBand> */}
          </Grid>

          <Grid item xs={12} md={4}>
            <img
              style={{
                maxWidth: "180px",
                width: "100%",
                display: matches ? "none" : "block",
              }}
              className="zoom-in-out-box"
              src={rightH}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Footer;
